<template>

   <v-container
    id="locations"
    fluid
    tag="section"
  >
    <base-v-component
      heading="Locations"
      link="locations/list"
    />

          
       <base-material-card
      icon="mdi-map-marker"
      title="Locations"
      class="px-5 py-3"
    >
    
           <h4 class="card-title font-weight-light mt-2 ml-2">Add location</h4>
           <v-form @submit.prevent="onFormSubmit">
            <v-container class="py-0">
              <v-row>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-text-field
          
                 label="Name" v-model="location.name" required />
                   <v-col
                  cols="12"
                  md="4"
                > </v-col>
                <v-col>
                <v-text-field

                    label="Description" v-model="location.description" />
               </v-col>

                <v-col
                  cols="12"
                  md="6"
                >
       <h4 class="display-2 font-weight-light mb-3 black--text">Upload an image </h4>
                 <vue-dropzone
      ref="imgDropZone"
      id="customdropzone"
      :options="dropzoneOptions"
      @vdropzone-complete="afterComplete"
    ></vue-dropzone>
    <div v-if="images.length > 0" class="image-div">
      <div v-for="image in images" :key="image.src">
        <img :src="image.src" class="image" />
      </div>
    </div>

                </v-col>
                
                 <v-col
                  cols="12"
                  class="text-right"
                >
                    <v-btn  color="success"
              rounded @click="onFormSubmit">   Add location </v-btn>
                </v-col> 
              </v-row>
            </v-container>
          </v-form>
        </base-material-card>
</template>

<script>
    import { db } from '../../../firebaseDb';
import firebase from "firebase";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
let uuid = require("uuid");
    export default {
       components: {
    vueDropzone: vue2Dropzone
  },
        data() {
           
    return {
      dropzoneOptions: {
        url: "https://httpbin.org/post",
        thumbnailWidth: 150,
        thumbnailHeight: 150,
        addRemoveLinks: false,
        acceptedFiles: ".jpg, .jpeg, .png",
        dictDefaultMessage: `<p class='text-default'><i class='fa fa-cloud-upload mr-2'></i> Drag Images or Click Here</p>
          <p class="form-text">Allowed Files: .jpg, .jpeg, .png</p>
          `
      },
      images: [],
    
                location: {
                }
            }
        },
        methods:         {
    async afterComplete(upload) {
      var imageName = uuid.v1();
      this.isLoading = true;
      try {
        //save image
        let file = upload;
        var metadata = {
          contentType: "image/png"
        };
        var storageRef = firebase.storage().ref();
        var imageRef = storageRef.child(`images/${imageName}.png`);
        await imageRef.put(file, metadata);
        var downloadURL = await imageRef.getDownloadURL();
        this.images.push({ src: downloadURL });
        
      } catch (error) {
        console.log(error);
      }
      this.$refs.imgDropZone.removeFile(upload);
    },
      
             onFormSubmit(event) {
                event.preventDefault()
                db.collection('locations').add(this.location).then(() => {
                    alert("location successfully created!");
                    this.location.name = ''
                    this.location.description = ''
                    this.location.img =  `'${downloadURL}`
                }).catch((error) => {
                    console.log(error);
                });
            }
        }
    }
</script>
<style>
.image-div {
  display: flex;
  margin: 25px;
}
.image {
  max-width: 250px;
  margin: 15px;
}
</style>